import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { armAudio, setEnabled, audioConfig, startDrone, stopDrone, isEnabled } from "@/lib/audio";

/**
 * Tiny NavBar audio toggle. Muted by default (per browser policy).
 * One click arms the WebAudio context AND persists the choice.
 */
export default function AudioToggle() {
  const [on, setOn] = useState(isEnabled());

  useEffect(() => {
    if (on) {
      armAudio();
      startDrone();
    } else {
      stopDrone();
    }
  }, [on]);

  const toggle = () => {
    armAudio();
    const next = !audioConfig().enabled;
    setEnabled(next);
    setOn(next);
  };

  return (
    <button
      onClick={toggle}
      className={`p-1.5 hover:text-blood transition-colors ${on ? "text-blood" : "text-muted-h"}`}
      title={on ? "Silence the dirt" : "Wake the dirt"}
      data-testid="audio-toggle"
      aria-label={on ? "Mute audio" : "Enable audio"}
    >
      {on ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
    </button>
  );
}
